import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import PropTypes from 'prop-types'
import styles from './registrationStudentForm.scss'
import FloatLabelInput from '../components/floatLabelInput/floatLabelInputComponent'
import { registerStudentValidator } from 'tmw-validation'

export function RegistrationStudentForm (props) {
  const { t, handleSubmit } = props
  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <Field
        name='firstName'
        component={FloatLabelInput}
        placeholder={t('form:firstNamePlaceholder')}
        type='text'
        label={t('form:firstName')}
      />
      {props.hasMou &&
        <Field
          name='lastName'
          component={FloatLabelInput}
          placeholder={t('form:lastNamePlaceholder')}
          type='text'
          label={t('form:lastName')}
        />}
      {props.hasMou &&
        <Field
          name='birthDate'
          component={FloatLabelInput}
          placeholder='YYYY-MM-DD'
          type='text'
          label={t('form:birthDate')}
        />}

      <button type='submit' className={styles.bigButton}>
        {t('form:next')}
      </button>
    </form>
  )
}

RegistrationStudentForm.propTypes = {
  hasMou: PropTypes.bool,
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

const boundActions = {}

function mapStateToProps (state, props) {
  return {
    hasMou: state.autoSuggest.hasMou
  }
}

export default compose(
  pure,
  translate(),
  connect(mapStateToProps, boundActions),
  reduxForm({
    validate: registerStudentValidator,
    form: 'registration',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(RegistrationStudentForm)



// WEBPACK FOOTER //
// ./src/forms/registrationStudent/registrationStudentForm.js